"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1459],{

/***/ 52591:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _hooks_useAnimateState__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1303);
/* harmony import */ var _vendor_scroll_locker_useScrollLocker__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(77027);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(86010);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);





const Modal = (param)=>{
    let { className , header , headerClassName , contentClassName , footerClassName , bodyClassName , footer , open , children , onClose  } = param;
    const [isOpen, setIsOpen] = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(open);
    (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(()=>{
        setIsOpen(open);
    }, [
        open
    ]);
    const { trigger , triggerClose  } = (0,_hooks_useAnimateState__WEBPACK_IMPORTED_MODULE_1__/* .useAnimateState */ .T)({
        open: isOpen,
        handleClose: ()=>{
            onClose ? onClose() : setIsOpen(false);
        }
    });
    const handleClose = (0,react__WEBPACK_IMPORTED_MODULE_3__.useCallback)((e)=>{
        if (e.type === "keydown" && e.key === "Escape" || e.type === "click" || e.type === "mousedown") {
            triggerClose();
        }
    }, [
        triggerClose
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(()=>{
        if (isOpen) {
            (0,_vendor_scroll_locker_useScrollLocker__WEBPACK_IMPORTED_MODULE_2__/* .lockScroll */ .dg)();
            window.addEventListener("keydown", handleClose);
        }
        return ()=>{
            (0,_vendor_scroll_locker_useScrollLocker__WEBPACK_IMPORTED_MODULE_2__/* .unlockScroll */ .pX)();
            window.removeEventListener("keydown", handleClose);
        };
    }, [
        isOpen,
        handleClose
    ]);
    return isOpen ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)("wrap-modal duration-300", className, trigger ? "opacity-100" : "opacity-0"),
        onMouseDown: (e)=>{
            handleClose(e);
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: (0,clsx__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)("wrap-modal-content", contentClassName),
            onMouseDown: (e)=>{
                // var target = getSelectedElementFromPoint(e.clientX, e.clientY);
                e.stopPropagation();
                return;
            },
            onClick: (e)=>e.stopPropagation(),
            children: [
                header ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: (0,clsx__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)("modal-header", headerClassName),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            children: header
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            onClick: handleClose,
                            className: "cursor-pointer text-fs-24 text-grey-800",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                                className: "mrv mrv-close"
                            })
                        })
                    ]
                }) : null,
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: (0,clsx__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)("modal-body", bodyClassName),
                    children: children
                }),
                footer ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: (0,clsx__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)("modal-footer", footerClassName),
                    children: footer
                }) : null
            ]
        })
    }) : null;
};
/* harmony default export */ __webpack_exports__["Z"] = (Modal);


/***/ }),

/***/ 71459:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Home; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/context/home.context.tsx
var home_context = __webpack_require__(61128);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components/Button.tsx + 1 modules
var Button = __webpack_require__(40364);
// EXTERNAL MODULE: ./src/components/MeeyImage.tsx
var MeeyImage = __webpack_require__(3524);
// EXTERNAL MODULE: ./src/components/PopupAvatarUser/index.tsx
var PopupAvatarUser = __webpack_require__(84536);
// EXTERNAL MODULE: ./src/constants/environment.ts
var environment = __webpack_require__(7181);
// EXTERNAL MODULE: ./src/hooks/useAuth.tsx + 2 modules
var useAuth = __webpack_require__(33172);
// EXTERNAL MODULE: ./src/api/endpoint/search/save-search-history.ts
var save_search_history = __webpack_require__(36361);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/modules/Desktop/Home/HeaderHome/LocationSelect/index.tsx + 4 modules
var LocationSelect = __webpack_require__(73885);
// EXTERNAL MODULE: ./src/modules/Desktop/Home/HeaderHome/SearchProject.tsx
var SearchProject = __webpack_require__(82620);
;// CONCATENATED MODULE: ./src/modules/Desktop/Home/HeaderHome/HomeBannerSearchBox.tsx








/* eslint-disable @next/next/no-img-element */ const HomeBannerSearchBox = ()=>{
    const [valueSearch, setValueSearch] = (0,react.useState)({
        text: "",
        location: {
            city: [],
            district: [],
            ward: []
        }
    });
    const { userDataHeader  } = (0,useAuth/* useAuth */.a)();
    const { push  } = (0,router.useRouter)();
    const handleSaveSearchHistory = async (project)=>{
        try {
            var _valueSearch_text;
            await (0,save_search_history/* saveSearchHistory */.B)({
                keywords: project ? (project === null || project === void 0 ? void 0 : project.title) || (project === null || project === void 0 ? void 0 : project.keywords) : valueSearch === null || valueSearch === void 0 ? void 0 : (_valueSearch_text = valueSearch.text) === null || _valueSearch_text === void 0 ? void 0 : _valueSearch_text.trim(),
                project: project === null || project === void 0 ? void 0 : project._id
            }, userDataHeader);
        } catch (error) {
            console.log(error);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: " flex items-center bg-white rounded-lg w-fit relative",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LocationSelect/* default */.Z, {
                onChange: (value)=>{
                    setValueSearch({
                        ...valueSearch,
                        location: value
                    });
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchProject/* default */.Z, {
                onChangeText: (value)=>{
                    setValueSearch({
                        ...valueSearch,
                        text: value
                    });
                },
                valueSearch: valueSearch,
                onPressEnter: ()=>{
                    var _valueSearch_location_city, _valueSearch_location_district, _valueSearch_location_ward;
                    push({
                        pathname: "/search",
                        query: {
                            title: valueSearch.text,
                            city: (_valueSearch_location_city = valueSearch.location.city) === null || _valueSearch_location_city === void 0 ? void 0 : _valueSearch_location_city.map((e)=>e._id),
                            district: (_valueSearch_location_district = valueSearch.location.district) === null || _valueSearch_location_district === void 0 ? void 0 : _valueSearch_location_district.map((e)=>e._id),
                            ward: (_valueSearch_location_ward = valueSearch.location.ward) === null || _valueSearch_location_ward === void 0 ? void 0 : _valueSearch_location_ward.map((e)=>e._id)
                        }
                    });
                },
                className: "w-[20rem]"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                className: "px-4 py-2.5 h-9 mr-1 text-base font-medium ",
                color: "primary",
                btnType: "filled",
                onClick: ()=>{
                    var _valueSearch_location_city, _valueSearch_location_district, _valueSearch_location_ward;
                    if (valueSearch.text) {
                        handleSaveSearchHistory();
                    // handleSearch(valueInput);
                    }
                    push({
                        pathname: "/search",
                        query: {
                            title: valueSearch.text,
                            city: (_valueSearch_location_city = valueSearch.location.city) === null || _valueSearch_location_city === void 0 ? void 0 : _valueSearch_location_city.map((e)=>e._id),
                            district: (_valueSearch_location_district = valueSearch.location.district) === null || _valueSearch_location_district === void 0 ? void 0 : _valueSearch_location_district.map((e)=>e._id),
                            ward: (_valueSearch_location_ward = valueSearch.location.ward) === null || _valueSearch_location_ward === void 0 ? void 0 : _valueSearch_location_ward.map((e)=>e._id)
                        }
                    });
                },
                children: "T\xecm kiếm"
            })
        ]
    });
};
/* harmony default export */ var HeaderHome_HomeBannerSearchBox = (HomeBannerSearchBox);

// EXTERNAL MODULE: ./src/constants/emoji.ts
var emoji = __webpack_require__(69068);
// EXTERNAL MODULE: ./src/utils/datetime.ts + 1 modules
var datetime = __webpack_require__(61297);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./src/modules/Desktop/Home/HeaderHome/ListScrollHotReview.tsx






let isDown = false;
let startX;
let scrollLeft;
let scrolldelay;
let scrollToLeft = false;
const getRandomEmoji = (cat, sub)=>{
    const random = (array)=>array[~~(Math.random() * array.length)];
    if (!emoji/* emojis */.S[cat]) cat = random(Object.keys(emoji/* emojis */.S));
    if (!emoji/* emojis */.S[cat][sub]) sub = random(Object.keys(emoji/* emojis */.S[cat]));
    return random(emoji/* emojis */.S[cat][sub]);
};
const ListScrollHotReview = ()=>{
    var _listTopAnimation_results, _listTopAnimation_results1;
    const { listTopAnimation  } = (0,react.useContext)(home_context/* HomeContext */.Q);
    const scrollEl = (0,react.useRef)(null);
    const [mounted, setMounted] = (0,react.useState)(false);
    const pageScroll = (0,react.useCallback)(()=>{
        if (scrollEl.current && scrollEl.current.scrollWidth > scrollEl.current.clientWidth) {
            if (scrollToLeft) {
                scrollEl.current.scrollLeft = scrollEl.current.scrollLeft - 1;
            } else scrollEl.current.scrollLeft = scrollEl.current.scrollLeft + 1;
            if (scrollEl.current.scrollLeft + scrollEl.current.offsetWidth + 2 > scrollEl.current.scrollWidth) {
                scrollToLeft = true;
            // scrollEl.current.scrollLeft = scrollEl.current.scrollLeft - 1;
            }
            if (scrollEl.current.scrollLeft < 2) {
                scrollToLeft = false;
            // scrollEl.current.scrollLeft = scrollEl.current.scrollLeft + 1;
            }
            scrolldelay = setTimeout(pageScroll, 10);
        }
    }, []);
    (0,react.useEffect)(()=>{
        setMounted(true);
        pageScroll();
        return ()=>{
            clearTimeout(scrolldelay);
        };
    }, [
        pageScroll
    ]);
    return (listTopAnimation === null || listTopAnimation === void 0 ? void 0 : (_listTopAnimation_results = listTopAnimation.results) === null || _listTopAnimation_results === void 0 ? void 0 : _listTopAnimation_results.length) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "flex overflow-hidden w-full gap-3 mt-7 cursor-pointe select-none cursor-pointer",
        ref: scrollEl,
        draggable: "false",
        onMouseDown: (e)=>{
            isDown = true;
            startX = e.pageX - scrollEl.current.offsetLeft;
            scrollLeft = scrollEl.current.scrollLeft;
        },
        onMouseOver: ()=>{
            clearTimeout(scrolldelay);
        },
        onMouseOut: ()=>{
            pageScroll();
        },
        onMouseLeave: (e)=>{
            isDown = false;
        },
        onMouseUp: (e)=>{
            e.preventDefault();
            isDown = false;
        },
        onMouseMove: (e)=>{
            if (!isDown) return;
            e.preventDefault();
            const x = e.pageX - scrollEl.current.offsetLeft;
            const walk = (x - startX) * 3; //scroll-fast
            scrollEl.current.scrollLeft = scrollLeft - walk;
        },
        children: listTopAnimation === null || listTopAnimation === void 0 ? void 0 : (_listTopAnimation_results1 = listTopAnimation.results) === null || _listTopAnimation_results1 === void 0 ? void 0 : _listTopAnimation_results1.map((item)=>{
            var _item_label, _item_project;
            /*#__PURE__*/ return (0,jsx_runtime.jsxs)((link_default()), {
                href: "/review/".concat(item._id),
                draggable: "false",
                className: "py-1 px-3 whitespace-nowrap text-fs-12 bg-blue-600 text-white rounded-lg hover:text-grey-100 self-center align-middle leading-[18px]",
                children: [
                    mounted ? [
                        1,
                        2,
                        3
                    ].map((e)=>getRandomEmoji()).join("") : null,
                    " ",
                    item.nickName ? item.nickName : "Ẩn danh",
                    " vừa",
                    " ",
                    item === null || item === void 0 ? void 0 : (_item_label = item.label) === null || _item_label === void 0 ? void 0 : _item_label.toLocaleLowerCase(),
                    " ",
                    (_item_project = item.project) === null || _item_project === void 0 ? void 0 : _item_project.title,
                    " ",
                    mounted ? [
                        1,
                        2,
                        3
                    ].map((e)=>getRandomEmoji()).join("") : null,
                    " !!!",
                    " ",
                    mounted ? (0,datetime/* getRelativeTime */.ni)(item === null || item === void 0 ? void 0 : item.publishedAt) : null
                ]
            }, item._id);
        })
    }) : null;
};
/* harmony default export */ var HeaderHome_ListScrollHotReview = (ListScrollHotReview);

// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./src/components/PopupNotification/index.tsx
var PopupNotification = __webpack_require__(8440);
;// CONCATENATED MODULE: ./src/modules/Desktop/Home/HeaderHome/index.tsx










const ModalAddReview = dynamic_default()(Promise.all(/* import() */[__webpack_require__.e(2678), __webpack_require__.e(6140), __webpack_require__.e(7703)]).then(__webpack_require__.bind(__webpack_require__, 22881)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(22881)
            ]
    },
    ssr: false
});

/* eslint-disable @next/next/no-img-element */ const HeaderHome = (param)=>{
    let { isShowScrolHeader  } = param;
    const { user , login  } = (0,useAuth/* useAuth */.a)();
    const [mounted, setMounted] = (0,react.useState)(false);
    (0,react.useEffect)(()=>{
        setMounted(true);
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "bg-header h-64",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex justify-between pt-4 px-[60px]",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "cursor-pointer",
                            onClick: ()=>{
                                var _window_location;
                                window === null || window === void 0 ? void 0 : (_window_location = window.location) === null || _window_location === void 0 ? void 0 : _window_location.reload();
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MeeyImage/* default */.Z, {
                                src: environment/* STATIC_DOMAIN */.xm + "/logo.svg",
                                alt: "home",
                                resizeOnFly: false,
                                resizeOptions: {
                                    width: 131,
                                    height: 42
                                }
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex items-center gap-5",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalAddReview, {
                                    buttonClassName: "!h-9"
                                }),
                                !user ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                    color: "white",
                                    className: "!h-9 ml-5",
                                    onClick: login,
                                    prefixIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                        className: "mrv mrv-account_circle text-fs-18",
                                        children: " "
                                    }),
                                    children: "Đăng nhập"
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(PopupNotification/* default */.Z, {
                                            isShowScrolHeader: isShowScrolHeader
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(PopupAvatarUser/* default */.Z, {})
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "ml-44 mt-7 w-fit",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                            className: "text-white text-5xl font-semibold mb-3",
                            children: "Review dự \xe1n"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "text-base mb-5 text-white",
                            children: "Cập nhật li\xean tục th\xf4ng tin b\xean lề hấp dẫn của 5000 dự \xe1n tr\xean to\xe0n quốc"
                        }),
                        mounted ? /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderHome_HomeBannerSearchBox, {}) : null
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderHome_ListScrollHotReview, {})
            ]
        })
    });
};
/* harmony default export */ var Home_HeaderHome = (HeaderHome);

// EXTERNAL MODULE: ./src/api/endpoint/reviews/get-list.ts
var get_list = __webpack_require__(15508);
// EXTERNAL MODULE: ./src/constants/number.ts
var number = __webpack_require__(20691);
// EXTERNAL MODULE: ./node_modules/react-infinite-scroll-component/dist/index.es.js
var index_es = __webpack_require__(58533);
// EXTERNAL MODULE: ./src/components/PopOver/index.tsx + 2 modules
var PopOver = __webpack_require__(20951);
// EXTERNAL MODULE: ./src/components/ReviewShowTextContent.tsx
var ReviewShowTextContent = __webpack_require__(54370);
// EXTERNAL MODULE: ./src/components/UserTime.tsx
var UserTime = __webpack_require__(23768);
// EXTERNAL MODULE: ./src/constants/common-constant.ts
var common_constant = __webpack_require__(17785);
// EXTERNAL MODULE: ./src/constants/image.ts
var constants_image = __webpack_require__(24435);
// EXTERNAL MODULE: ./src/constants/project-constant.ts
var project_constant = __webpack_require__(18825);
// EXTERNAL MODULE: ./src/utils/index.ts + 2 modules
var utils = __webpack_require__(67650);
// EXTERNAL MODULE: ./src/constants/file.ts
var constants_file = __webpack_require__(32336);
;// CONCATENATED MODULE: ./src/modules/Desktop/Home/HomeProjectCard.tsx














const ListFileReview = dynamic_default()(Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 47565)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(47565)
            ]
    },
    ssr: false
});
const HomeProjectCard = (param)=>{
    let { data , loading  } = param;
    var _data_logo, _data_voteScore, _data_latestComment, _data_latestComment1, _data_latestComment2, _data_latestComment3;
    const urlUserAvatar = (0,react.useMemo)(()=>{
        var _data_latestComment, _data_latestComment_createdBy, _data_latestComment1;
        if (data === null || data === void 0 ? void 0 : (_data_latestComment = data.latestComment) === null || _data_latestComment === void 0 ? void 0 : (_data_latestComment_createdBy = _data_latestComment.createdBy) === null || _data_latestComment_createdBy === void 0 ? void 0 : _data_latestComment_createdBy.avatar) {
            var _data_latestComment2, _data_latestComment_createdBy1, _data_latestComment3, _data_latestComment_createdBy2, _data_latestComment4, _data_latestComment_createdBy3, _data_latestComment5, _data_latestComment_createdBy4;
            return (data === null || data === void 0 ? void 0 : (_data_latestComment2 = data.latestComment) === null || _data_latestComment2 === void 0 ? void 0 : (_data_latestComment_createdBy1 = _data_latestComment2.createdBy) === null || _data_latestComment_createdBy1 === void 0 ? void 0 : _data_latestComment_createdBy1.avatar.includes(environment/* MEDIA_URL */.eR)) && (data === null || data === void 0 ? void 0 : (_data_latestComment3 = data.latestComment) === null || _data_latestComment3 === void 0 ? void 0 : (_data_latestComment_createdBy2 = _data_latestComment3.createdBy) === null || _data_latestComment_createdBy2 === void 0 ? void 0 : _data_latestComment_createdBy2.avatar.match(constants_file/* fileType.resizeImageSupport */.r.resizeImageSupport)) ? (0,utils/* resizeOnFlyUrl */.Li)({
                uri: data === null || data === void 0 ? void 0 : (_data_latestComment4 = data.latestComment) === null || _data_latestComment4 === void 0 ? void 0 : (_data_latestComment_createdBy3 = _data_latestComment4.createdBy) === null || _data_latestComment_createdBy3 === void 0 ? void 0 : _data_latestComment_createdBy3.avatar.replace(environment/* MEDIA_URL */.eR, ""),
                width: 32,
                height: 32,
                gravity: "ce",
                resizingType: "auto"
            }) : data === null || data === void 0 ? void 0 : (_data_latestComment5 = data.latestComment) === null || _data_latestComment5 === void 0 ? void 0 : (_data_latestComment_createdBy4 = _data_latestComment5.createdBy) === null || _data_latestComment_createdBy4 === void 0 ? void 0 : _data_latestComment_createdBy4.avatar;
        } else if (data === null || data === void 0 ? void 0 : (_data_latestComment1 = data.latestComment) === null || _data_latestComment1 === void 0 ? void 0 : _data_latestComment1.nickName) {
            return null;
        } else return "".concat(environment/* STATIC_DOMAIN */.xm, "/").concat(constants_image/* DEFAULT_USER_AVATAR */._D);
    }, [
        data
    ]);
    const [isShowMore, setIsShowMore] = (0,react.useState)(false);
    (0,react.useEffect)(()=>{
        const reviewEle = document.getElementById("review-".concat(data === null || data === void 0 ? void 0 : data._id));
        if (!reviewEle) setIsShowMore(false);
        setIsShowMore((reviewEle === null || reviewEle === void 0 ? void 0 : reviewEle.scrollHeight) > (reviewEle === null || reviewEle === void 0 ? void 0 : reviewEle.offsetHeight));
    }, [
        data
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
        href: "/project/".concat(data.slug, "-").concat(data.shortId ? data.shortId : data._id),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "flex gap-4 pt-2 pr-4 pb-3 pl-2 w-full bg-white rounded-lg cursor-pointer shadow hover:shadow-xl duration-300 shrink-0",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "w-[3.75rem] h-[3.75rem] relative shrink-0",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MeeyImage/* default */.Z, {
                        src: data.logo ? data.logo.uri : "".concat(environment/* STATIC_DOMAIN */.xm, "/").concat(project_constant/* DEFAULT_LOGO_PROJECT */.J3),
                        alt: data.title,
                        resizeOnFly: !!(data === null || data === void 0 ? void 0 : (_data_logo = data.logo) === null || _data_logo === void 0 ? void 0 : _data_logo.uri),
                        resizeOptions: {
                            width: 0,
                            height: 60
                        },
                        className: "w-full h-full absolute object-contain rounded border border-solid border-grey-100"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex-1",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex justify-between items-center w-full border-b border-dashed border-grey-300 pb-3 gap-3",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex-0",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "text-fs-18 text-grey-700 font-semibold flex items-center gap-3",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(PopOver/* default */.Z, {
                                                    trigger: "hover",
                                                    dropdownClassName: "mt-2 !p-0 rounded !bg-transparent",
                                                    content: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "py-1 px-2 bg-black-800 text-fs-14 text-white max-w-[30rem] break-word",
                                                        children: data === null || data === void 0 ? void 0 : data.title
                                                    }),
                                                    position: "top-left",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "text-grey-800 text-fs-18 font-semibold line-clamp-1 break-words",
                                                        children: data === null || data === void 0 ? void 0 : data.title
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "flex items-center gap-1 shrink-0",
                                                    children: [
                                                        (data === null || data === void 0 ? void 0 : data.voteScore) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                            children: [
                                                                (data === null || data === void 0 ? void 0 : data.fluctuationScore) == common_constant/* FluctuationScoreEnum.DOWN */._6.DOWN ? /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                                    className: "mrv mrv-trending_down text-red-600 text-fs-20"
                                                                }) : null,
                                                                (data === null || data === void 0 ? void 0 : data.fluctuationScore) == common_constant/* FluctuationScoreEnum.UP */._6.UP ? /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                                    className: "mrv mrv-trending_up text-green-500 text-fs-20"
                                                                }) : null,
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                    className: "text-fs-14 text-grey-700 font-normal",
                                                                    children: Number.isInteger(data === null || data === void 0 ? void 0 : data.voteScore) ? data === null || data === void 0 ? void 0 : data.voteScore : data === null || data === void 0 ? void 0 : (_data_voteScore = data.voteScore) === null || _data_voteScore === void 0 ? void 0 : _data_voteScore.toFixed(1)
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                                    className: "mrv mrv-star text-[#FFC633] text-fs-20"
                                                                })
                                                            ]
                                                        }) : null,
                                                        (data === null || data === void 0 ? void 0 : data.totalHotReview) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                            className: "text-fs-14 text-grey-700 font-normal",
                                                            children: [
                                                                "(",
                                                                data === null || data === void 0 ? void 0 : data.totalHotReview,
                                                                " reviews)"
                                                            ]
                                                        }) : null
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "text-fs-14 text-grey-500 mt-0.5",
                                            children: (0,utils/* convertAddressNoStreet */.NL)(data)
                                        })
                                    ]
                                }),
                                (data === null || data === void 0 ? void 0 : data.totalView) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "text-grey-500 text-fs-14 flex items-center gap-1 shrink-0",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            children: data === null || data === void 0 ? void 0 : data.totalView
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                            className: "mrv mrv-visibility text-grey-400 text-fs-20"
                                        })
                                    ]
                                }) : null
                            ]
                        }),
                        (data === null || data === void 0 ? void 0 : data.latestComment) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "mt-2",
                            children: [
                                (data === null || data === void 0 ? void 0 : (_data_latestComment = data.latestComment) === null || _data_latestComment === void 0 ? void 0 : _data_latestComment.comment) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "text-fs-14 text-grey-700 line-clamp-2 break-word w-full relative leading-6",
                                    id: "review-".concat(data === null || data === void 0 ? void 0 : data._id),
                                    children: [
                                        "“",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ReviewShowTextContent/* default */.Z, {
                                            content: data === null || data === void 0 ? void 0 : (_data_latestComment1 = data.latestComment) === null || _data_latestComment1 === void 0 ? void 0 : _data_latestComment1.comment
                                        }),
                                        "”",
                                        isShowMore ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "absolute top-5 right-0",
                                            children: "”"
                                        }) : null
                                    ]
                                }) : null,
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ListFileReview, {
                                    data: data === null || data === void 0 ? void 0 : data.latestComment
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "flex mt-1.5 items-center gap-4",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(UserTime/* default */.Z, {
                                        src: urlUserAvatar,
                                        name: (data === null || data === void 0 ? void 0 : (_data_latestComment2 = data.latestComment) === null || _data_latestComment2 === void 0 ? void 0 : _data_latestComment2.nickName) || "Ẩn danh",
                                        className: "w-fit",
                                        textClass: "text-fs-14 text-grey-600",
                                        size: 24,
                                        time: data === null || data === void 0 ? void 0 : (_data_latestComment3 = data.latestComment) === null || _data_latestComment3 === void 0 ? void 0 : _data_latestComment3.publishedAt,
                                        maxLengthName: 50
                                    })
                                })
                            ]
                        }) : null
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var Home_HomeProjectCard = (HomeProjectCard);

// EXTERNAL MODULE: ./node_modules/axios/lib/axios.js + 40 modules
var axios = __webpack_require__(6154);
// EXTERNAL MODULE: ./src/components/MeeyRate.tsx
var MeeyRate = __webpack_require__(14759);
;// CONCATENATED MODULE: ./src/modules/common/Home/SeenProjectCard.tsx






const SeenProjectCard = (param)=>{
    let { item  } = param;
    var _item_project, _item_project_banner, _item_project_voteScore;
    var _item_project_banner_uri;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)((link_default()), {
        href: "/project/".concat(item.project.slug, "-").concat(item.project.shortId),
        className: "gap-4 px-4 py-2 w-full bg-white rounded-lg duration-300 cursor-pointer",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MeeyImage/* default */.Z, {
                src: (_item_project_banner_uri = (_item_project = item.project) === null || _item_project === void 0 ? void 0 : (_item_project_banner = _item_project.banner) === null || _item_project_banner === void 0 ? void 0 : _item_project_banner.uri) !== null && _item_project_banner_uri !== void 0 ? _item_project_banner_uri : constants_image/* DEFAULT_IMAGE_URI */.mG,
                resizeOptions: {
                    width: 284,
                    height: 91
                },
                alt: item.project.title,
                className: "rounded-lg object-cover w-full"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PopOver/* default */.Z, {
                trigger: "hover",
                dropdownClassName: "!bg-[rgba(0,0,0,0.8)] !p-2 rounded",
                content: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: " text-white max-w-[160px] rounded",
                    children: item.project.title
                }),
                position: "top-left",
                className: "text-grey-800 font-semibold mt-2 line-clamp-1",
                children: item.project.title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex gap-1 items-center",
                children: [
                    item.project.voteScore ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "text-fs-14 text-grey-800",
                                children: (_item_project_voteScore = item.project.voteScore) === null || _item_project_voteScore === void 0 ? void 0 : _item_project_voteScore.toFixed(1)
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(MeeyRate/* default */.Z, {
                                disable: true,
                                itemClassName: "!text-fs-24",
                                value: Math.floor(item.project.voteScore)
                            })
                        ]
                    }) : null,
                    item.project.totalHotReview ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "text-fs-14 text-grey-800",
                        children: [
                            "(",
                            item.project.totalHotReview,
                            " reviews)"
                        ]
                    }) : null
                ]
            })
        ]
    });
};
/* harmony default export */ var Home_SeenProjectCard = (SeenProjectCard);

;// CONCATENATED MODULE: ./src/modules/common/Home/SeenProjects.tsx






const SeenProjects = ()=>{
    const [data, setData] = (0,react.useState)([]);
    const { userDataHeader  } = (0,useAuth/* useAuth */.a)();
    const getData = (0,react.useCallback)(async ()=>{
        if (userDataHeader) try {
            const res = await axios/* default.request */.Z.request({
                baseURL: environment/* MEEY_REVIEW_API_URL */.HG,
                url: "/v1/user/topviewed",
                headers: {
                    ...userDataHeader
                }
            });
            setData(res.data);
        } catch (error) {}
    }, [
        userDataHeader
    ]);
    (0,react.useEffect)(()=>{
        getData();
    }, [
        getData
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: data && (data === null || data === void 0 ? void 0 : data.length) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "uppercase text-grey-700 text-fs-14 font-semibold mb-3",
                    children: "\uD83C\uDFE2 dự \xe1n đ\xe3 xem"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "w-full flex md:flex-col gap-3 md:bg-white rounded-lg md:max-h-[726px] overflow-auto pt-2 ",
                    children: data.map((item, index)=>{
                        /*#__PURE__*/ return (0,jsx_runtime.jsx)(Home_SeenProjectCard, {
                            item: item
                        }, item === null || item === void 0 ? void 0 : item._id);
                    })
                })
            ]
        }) : null
    });
};
/* harmony default export */ var Home_SeenProjects = (SeenProjects);

// EXTERNAL MODULE: ./src/modules/common/ListFileReview.tsx
var common_ListFileReview = __webpack_require__(47565);
;// CONCATENATED MODULE: ./src/modules/Desktop/Home/Newest/BoxInfo/CommentStormCard.tsx







const CommentStormCard = (param)=>{
    let { reviewContent  } = param;
    var _reviewContent_review, _reviewContent_review1, _reviewContent_review_voteScore, _reviewContent_review2, _reviewContent_review3, _reviewContent_review4, _reviewContent_review_comment, _reviewContent_review5, _reviewContent_review6, _reviewContent_review7, _reviewContent_review_createdBy, _reviewContent_review8, _reviewContent_review9, _reviewContent_review10, _reviewContent_review11;
    var _reviewContent_review__id;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "p-3 w-full bg-white rounded-lg cursor-pointer shadow hover:shadow-xl duration-300 flex flex-col gap-2",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "flex flex-col gap-2",
            children: [
                (reviewContent === null || reviewContent === void 0 ? void 0 : (_reviewContent_review = reviewContent.review) === null || _reviewContent_review === void 0 ? void 0 : _reviewContent_review.voteScore) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex items-center gap-1 h-6",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "text-fs-14 text-grey-700",
                            children: reviewContent === null || reviewContent === void 0 ? void 0 : (_reviewContent_review1 = reviewContent.review) === null || _reviewContent_review1 === void 0 ? void 0 : (_reviewContent_review_voteScore = _reviewContent_review1.voteScore) === null || _reviewContent_review_voteScore === void 0 ? void 0 : _reviewContent_review_voteScore.toFixed(1)
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(MeeyRate/* default */.Z, {
                            disable: true,
                            value: reviewContent === null || reviewContent === void 0 ? void 0 : (_reviewContent_review2 = reviewContent.review) === null || _reviewContent_review2 === void 0 ? void 0 : _reviewContent_review2.voteScore,
                            itemClassName: "!text-fs-24"
                        })
                    ]
                }) : null,
                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                    href: "/project/".concat(reviewContent === null || reviewContent === void 0 ? void 0 : reviewContent.slug, "-").concat((reviewContent === null || reviewContent === void 0 ? void 0 : reviewContent.shortId) ? reviewContent === null || reviewContent === void 0 ? void 0 : reviewContent.shortId : reviewContent === null || reviewContent === void 0 ? void 0 : reviewContent._id),
                    title: reviewContent === null || reviewContent === void 0 ? void 0 : reviewContent._id,
                    target: "_blank",
                    className: "text-fs-14 font-semibold",
                    children: reviewContent === null || reviewContent === void 0 ? void 0 : reviewContent.title
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "text-fs-14 text-grey-700 break-word leading-6",
                    children: [
                        "“",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ReviewShowTextContent/* default */.Z, {
                            content: reviewContent === null || reviewContent === void 0 ? void 0 : (_reviewContent_review3 = reviewContent.review) === null || _reviewContent_review3 === void 0 ? void 0 : _reviewContent_review3.comment,
                            limit: 200
                        }),
                        (reviewContent === null || reviewContent === void 0 ? void 0 : (_reviewContent_review4 = reviewContent.review) === null || _reviewContent_review4 === void 0 ? void 0 : (_reviewContent_review_comment = _reviewContent_review4.comment) === null || _reviewContent_review_comment === void 0 ? void 0 : _reviewContent_review_comment.length) > 200 ? " ..." : null,
                        "”"
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                    href: "/review/".concat(reviewContent === null || reviewContent === void 0 ? void 0 : (_reviewContent_review5 = reviewContent.review) === null || _reviewContent_review5 === void 0 ? void 0 : _reviewContent_review5._id),
                    target: "_blank",
                    title: (_reviewContent_review__id = reviewContent === null || reviewContent === void 0 ? void 0 : (_reviewContent_review6 = reviewContent.review) === null || _reviewContent_review6 === void 0 ? void 0 : _reviewContent_review6._id) !== null && _reviewContent_review__id !== void 0 ? _reviewContent_review__id : "",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(common_ListFileReview["default"], {
                        data: reviewContent === null || reviewContent === void 0 ? void 0 : reviewContent.review,
                        maxFileShow: 4
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: " mt-2.5 items-center gap-4",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(UserTime/* default */.Z, {
                        src: (reviewContent === null || reviewContent === void 0 ? void 0 : (_reviewContent_review7 = reviewContent.review) === null || _reviewContent_review7 === void 0 ? void 0 : (_reviewContent_review_createdBy = _reviewContent_review7.createdBy) === null || _reviewContent_review_createdBy === void 0 ? void 0 : _reviewContent_review_createdBy.avatar) ? (_reviewContent_review8 = reviewContent.review) === null || _reviewContent_review8 === void 0 ? void 0 : _reviewContent_review8.createdBy.avatar : (reviewContent === null || reviewContent === void 0 ? void 0 : (_reviewContent_review9 = reviewContent.review) === null || _reviewContent_review9 === void 0 ? void 0 : _reviewContent_review9.nickName) ? null : constants_image/* DEFAULT_IMAGE_CARD */.mq,
                        name: (reviewContent === null || reviewContent === void 0 ? void 0 : (_reviewContent_review10 = reviewContent.review) === null || _reviewContent_review10 === void 0 ? void 0 : _reviewContent_review10.nickName) || "Ẩn danh",
                        className: "w-fit",
                        textClass: "text-fs-14 text-grey-600 line-clamp-1",
                        size: 32,
                        time: reviewContent === null || reviewContent === void 0 ? void 0 : (_reviewContent_review11 = reviewContent.review) === null || _reviewContent_review11 === void 0 ? void 0 : _reviewContent_review11.publishedAt,
                        haveAction: true,
                        maxLengthName: 32
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var BoxInfo_CommentStormCard = (CommentStormCard);

;// CONCATENATED MODULE: ./src/modules/Desktop/Home/Newest/BoxInfo/CommentStorm.tsx




const CommentStorm = ()=>{
    var _listStormComment_results;
    const { listStormComment  } = (0,react.useContext)(home_context/* HomeContext */.Q);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: (listStormComment === null || listStormComment === void 0 ? void 0 : listStormComment.results) && (listStormComment === null || listStormComment === void 0 ? void 0 : (_listStormComment_results = listStormComment.results) === null || _listStormComment_results === void 0 ? void 0 : _listStormComment_results.length) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "uppercase text-grey-700 text-fs-14 font-semibold mb-1 py-2",
                    children: "b\xe3o b\xecnh luận \uD83D\uDD25\uD83D\uDD25\uD83D\uDD25\uD83D\uDD25"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "flex flex-col gap-3",
                    children: listStormComment === null || listStormComment === void 0 ? void 0 : listStormComment.results.map((item, index)=>{
                        /*#__PURE__*/ return (0,jsx_runtime.jsx)(BoxInfo_CommentStormCard, {
                            reviewContent: item
                        }, item === null || item === void 0 ? void 0 : item._id);
                    })
                })
            ]
        }) : null
    });
};
/* harmony default export */ var BoxInfo_CommentStorm = (CommentStorm);

// EXTERNAL MODULE: ./src/constants/enum/comment.ts
var comment = __webpack_require__(44352);
// EXTERNAL MODULE: ./src/components/Modal/index.tsx
var Modal = __webpack_require__(52591);
// EXTERNAL MODULE: ./node_modules/antd/es/form/index.js + 28 modules
var es_form = __webpack_require__(75632);
// EXTERNAL MODULE: ./node_modules/antd/es/notification/index.js + 5 modules
var notification = __webpack_require__(54689);
// EXTERNAL MODULE: ./node_modules/antd/es/input/index.js + 18 modules
var input = __webpack_require__(79415);
// EXTERNAL MODULE: ./src/modules/Desktop/Home/Newest/BoxInfo/InputReplyComponent.tsx
var InputReplyComponent = __webpack_require__(49860);
// EXTERNAL MODULE: ./src/api/endpoint/reviews/get-list-follow-project.ts
var get_list_follow_project = __webpack_require__(15082);
// EXTERNAL MODULE: ./src/constants/enum/media.ts
var media = __webpack_require__(71381);
;// CONCATENATED MODULE: ./src/modules/Desktop/Home/Newest/BoxInfo/ModalReplyFollowProject.tsx


















const FollowDetailFileList = dynamic_default()(__webpack_require__.e(/* import() */ 4709).then(__webpack_require__.bind(__webpack_require__, 34709)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(34709)
            ]
    },
    ssr: false
});
const ModalReplyFollowProject = (param)=>{
    let { open , onClose , reviewContent , userAction , urlUserAvatar  } = param;
    var _reviewContent_topreview, _reviewContent_topreview1, _reviewContent_topreview2, _reviewContent_topreview3, _reviewContent_title, _reviewContent_topreview4;
    const { setListFollowProject  } = (0,react.useContext)(home_context/* HomeContext */.Q);
    const [loading, setLoading] = (0,react.useState)(false);
    const { user , userDataHeader , token  } = (0,useAuth/* useAuth */.a)();
    const [form] = es_form/* default.useForm */.Z.useForm();
    (0,react.useEffect)(()=>{
        if (!open) form.resetFields();
    }, [
        form,
        open
    ]);
    (0,react.useEffect)(()=>{
        var _reviewContent_topreview, _reviewContent_topreview_createdBy, _reviewContent_topreview1;
        form.setFieldsValue({
            nickName: user === null || user === void 0 ? void 0 : user.name,
            comment: "@{{".concat(reviewContent === null || reviewContent === void 0 ? void 0 : (_reviewContent_topreview = reviewContent.topreview) === null || _reviewContent_topreview === void 0 ? void 0 : (_reviewContent_topreview_createdBy = _reviewContent_topreview.createdBy) === null || _reviewContent_topreview_createdBy === void 0 ? void 0 : _reviewContent_topreview_createdBy._id, "||").concat((reviewContent === null || reviewContent === void 0 ? void 0 : (_reviewContent_topreview1 = reviewContent.topreview) === null || _reviewContent_topreview1 === void 0 ? void 0 : _reviewContent_topreview1.nickName) || "anymos", "}} ")
        });
    }, [
        form,
        open,
        user
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "flex flex-col gap-4",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(es_form/* default */.Z, {
                form: form,
                initialValues: {
                    comment: null,
                    nickName: user === null || user === void 0 ? void 0 : user.name
                },
                labelAlign: "left",
                onFinish: async (value)=>{
                    setLoading(true);
                    try {
                        var _value_file, _value_file1, _reviewContent_topreview, _value_comment, _reviewContent_topreview1, _reviewContent_topreview_createdBy, _reviewContent_topreview2;
                        const mediaFile = (value === null || value === void 0 ? void 0 : value.file) && (value === null || value === void 0 ? void 0 : (_value_file = value.file) === null || _value_file === void 0 ? void 0 : _value_file.length) ? value === null || value === void 0 ? void 0 : (_value_file1 = value.file) === null || _value_file1 === void 0 ? void 0 : _value_file1.map((item)=>{
                            if (item.name.match(constants_file/* fileType.file */.r.file)) {
                                return {
                                    type: media/* MediaTypeEnum.FILE */.L.FILE,
                                    s3Keys: [
                                        item.s3Key
                                    ]
                                };
                            }
                            if (item.name.match(constants_file/* fileType.image */.r.image)) {
                                return {
                                    type: media/* MediaTypeEnum.IMAGE */.L.IMAGE,
                                    s3Keys: [
                                        item.s3Key
                                    ]
                                };
                            }
                            if (item.name.match(constants_file/* fileType.video */.r.video)) {
                                return {
                                    type: media/* MediaTypeEnum.VIDEO */.L.VIDEO,
                                    s3Keys: [
                                        item.s3Key
                                    ]
                                };
                            }
                        }) : [];
                        var _value_nickName;
                        const res = await axios/* default.request */.Z.request({
                            method: "post",
                            baseURL: environment/* MEEY_REVIEW_API_URL */.HG,
                            headers: {
                                ...userDataHeader
                            },
                            url: "v1/comments/" + (reviewContent === null || reviewContent === void 0 ? void 0 : (_reviewContent_topreview = reviewContent.topreview) === null || _reviewContent_topreview === void 0 ? void 0 : _reviewContent_topreview._id) + "/reply",
                            data: {
                                comment: (_value_comment = value.comment) === null || _value_comment === void 0 ? void 0 : _value_comment.trim(),
                                nickName: "".concat((_value_nickName = value.nickName) !== null && _value_nickName !== void 0 ? _value_nickName : ""),
                                links: value.comment.match(common_constant/* urlRegex */.yV) || [],
                                mentions: [
                                    {
                                        userId: reviewContent === null || reviewContent === void 0 ? void 0 : (_reviewContent_topreview1 = reviewContent.topreview) === null || _reviewContent_topreview1 === void 0 ? void 0 : (_reviewContent_topreview_createdBy = _reviewContent_topreview1.createdBy) === null || _reviewContent_topreview_createdBy === void 0 ? void 0 : _reviewContent_topreview_createdBy._id,
                                        nickName: (reviewContent === null || reviewContent === void 0 ? void 0 : (_reviewContent_topreview2 = reviewContent.topreview) === null || _reviewContent_topreview2 === void 0 ? void 0 : _reviewContent_topreview2.nickName) || ""
                                    }
                                ],
                                media: mediaFile
                            }
                        });
                        if (res) {
                            const resFollow = await (0,get_list_follow_project/* getListFollowProject */.q)(token);
                            setListFollowProject(resFollow);
                            onClose();
                        }
                    } catch (error) {
                        var _error_response, _error_response_data;
                        if ((error === null || error === void 0 ? void 0 : (_error_response = error.response) === null || _error_response === void 0 ? void 0 : (_error_response_data = _error_response.data) === null || _error_response_data === void 0 ? void 0 : _error_response_data.code) === 400) {
                            var _error_response1, _error_response_data1;
                            form.setFields([
                                {
                                    name: "comment",
                                    errors: [
                                        error === null || error === void 0 ? void 0 : (_error_response1 = error.response) === null || _error_response1 === void 0 ? void 0 : (_error_response_data1 = _error_response1.data) === null || _error_response_data1 === void 0 ? void 0 : _error_response_data1.message
                                    ]
                                }
                            ]);
                        } else notification/* default.error */.Z.error({
                            message: "C\xf3 lỗi xảy ra, vui l\xf2ng thử lại sau",
                            style: {
                                width: "100%",
                                top: 56
                            }
                        });
                    } finally{
                        setLoading(false);
                    }
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default */.Z, {
                        contentClassName: "w-[40.5rem]",
                        onClose: ()=>{
                            form.resetFields();
                            onClose();
                        },
                        headerClassName: "!bg-grey-100",
                        header: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "text-grey-800 text-fs-20 font-semibold",
                            children: (reviewContent === null || reviewContent === void 0 ? void 0 : (_reviewContent_topreview = reviewContent.topreview) === null || _reviewContent_topreview === void 0 ? void 0 : _reviewContent_topreview.type) == comment/* CommentTypeEnum.QUESTION */.I.QUESTION ? "Trả lời" : "Phản hồi"
                        }),
                        footer: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex w-full justify-end gap-4",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                    color: "grey",
                                    className: "!px-8",
                                    onClick: ()=>{
                                        form.resetFields();
                                        onClose();
                                    },
                                    children: "Hủy"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(es_form/* default.Item */.Z.Item, {
                                    noStyle: true,
                                    shouldUpdate: true,
                                    children: (param)=>{
                                        let { getFieldsError , isFieldTouched , getFieldValue  } = param;
                                        var _getFieldValue, _getFieldValue1, _reviewContent_topreview, _reviewContent_topreview1;
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                            btnType: "filled",
                                            type: "button",
                                            onClick: form.submit,
                                            className: "!px-9 ",
                                            disabled: loading || !((_getFieldValue = getFieldValue([
                                                "comment"
                                            ])) === null || _getFieldValue === void 0 ? void 0 : _getFieldValue.trim()) || ((_getFieldValue1 = getFieldValue([
                                                "comment"
                                            ])) === null || _getFieldValue1 === void 0 ? void 0 : _getFieldValue1.trim()) === "@".concat((reviewContent === null || reviewContent === void 0 ? void 0 : (_reviewContent_topreview = reviewContent.topreview) === null || _reviewContent_topreview === void 0 ? void 0 : _reviewContent_topreview.nickName) || "Ẩn danh") || getFieldsError().some((param)=>{
                                                let { errors  } = param;
                                                return errors.length;
                                            }),
                                            children: (reviewContent === null || reviewContent === void 0 ? void 0 : (_reviewContent_topreview1 = reviewContent.topreview) === null || _reviewContent_topreview1 === void 0 ? void 0 : _reviewContent_topreview1.type) == comment/* CommentTypeEnum.QUESTION */.I.QUESTION ? "Gửi trả lời" : "Gửi phản hồi"
                                        });
                                    }
                                })
                            ]
                        }),
                        open: open,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "max-h-[70vh] overflow-auto",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "p-3 border border-solid border-black-50 bg-grey-100 rounded-lg mb-4",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(UserTime/* default */.Z, {
                                            src: urlUserAvatar,
                                            name: (reviewContent === null || reviewContent === void 0 ? void 0 : (_reviewContent_topreview1 = reviewContent.topreview) === null || _reviewContent_topreview1 === void 0 ? void 0 : _reviewContent_topreview1.nickName) || "Ẩn danh",
                                            className: "w-fit",
                                            textClass: "text-fs-14 text-grey-600",
                                            size: 32,
                                            time: reviewContent === null || reviewContent === void 0 ? void 0 : (_reviewContent_topreview2 = reviewContent.topreview) === null || _reviewContent_topreview2 === void 0 ? void 0 : _reviewContent_topreview2.publishedAt,
                                            haveAction: true,
                                            actionTitle: userAction.title,
                                            actionIcon: (reviewContent === null || reviewContent === void 0 ? void 0 : (_reviewContent_topreview3 = reviewContent.topreview) === null || _reviewContent_topreview3 === void 0 ? void 0 : _reviewContent_topreview3.type) == comment/* CommentTypeEnum.QUESTION */.I.QUESTION ? /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                className: "mrv mrv-contact_support text-fs-20 leading-5 text-purple-500"
                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                className: "mrv mrv-review text-fs-20 leading-5 text-blue-500"
                                            }),
                                            aboutProject: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "text-fs-14 text-grey-600",
                                                        children: "về "
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "text-fs-14 text-grey-800 font-medium ",
                                                        children: (reviewContent === null || reviewContent === void 0 ? void 0 : (_reviewContent_title = reviewContent.title) === null || _reviewContent_title === void 0 ? void 0 : _reviewContent_title.length) > 45 ? (reviewContent === null || reviewContent === void 0 ? void 0 : reviewContent.title.substring(0, 45)) + "..." : reviewContent === null || reviewContent === void 0 ? void 0 : reviewContent.title
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "text-fs-14 text-grey-700 max-h-[139px] overflow-y-auto mt-2",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ReviewShowTextContent/* default */.Z, {
                                                content: reviewContent === null || reviewContent === void 0 ? void 0 : (_reviewContent_topreview4 = reviewContent.topreview) === null || _reviewContent_topreview4 === void 0 ? void 0 : _reviewContent_topreview4.comment
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(FollowDetailFileList, {
                                            data: reviewContent === null || reviewContent === void 0 ? void 0 : reviewContent.topreview,
                                            maxFileShow: 6
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(es_form/* default.Item */.Z.Item, {
                                    label: "Nickname cho bạn ",
                                    name: "nickName",
                                    labelCol: {
                                        span: 24
                                    },
                                    wrapperCol: {
                                        span: 24
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(input/* default */.Z, {
                                        maxLength: 50,
                                        size: "large",
                                        placeholder: "Đặt bất k\xec nickname n\xe0o bạn th\xedch",
                                        disabled: loading
                                    })
                                }),
                                form.getFieldValue("comment") ? /*#__PURE__*/ (0,jsx_runtime.jsx)(InputReplyComponent/* default */.Z, {
                                    setLoading: setLoading,
                                    loading: loading,
                                    label: comment/* CommentTypeEnum.QUESTION */.I.QUESTION ? "C\xe2u trả lời" : "Phản hồi",
                                    placeholder: comment/* CommentTypeEnum.QUESTION */.I.QUESTION ? "Viết nội dung trả lời" : "Viết nội dung phản hồi",
                                    requiredMessage: comment/* CommentTypeEnum.QUESTION */.I.QUESTION ? "Vui l\xf2ng nhập nội dung trả lời" : "Vui l\xf2ng nhập nội dung phản hồi",
                                    data: reviewContent === null || reviewContent === void 0 ? void 0 : reviewContent.topreview
                                }) : null
                            ]
                        })
                    }),
                    " "
                ]
            })
        })
    });
};
/* harmony default export */ var BoxInfo_ModalReplyFollowProject = (ModalReplyFollowProject);

;// CONCATENATED MODULE: ./src/modules/Desktop/Home/Newest/BoxInfo/FollowProjectCard.tsx
















const FollowProjectCard = (param)=>{
    let { reviewContent  } = param;
    var _reviewContent_voteScore, _reviewContent_topreview, _reviewContent_topreview1, _reviewContent_topreview2, _reviewContent_topreview3, _reviewContent_topreview4, _reviewContent_topreview_comment, _reviewContent_topreview5, _reviewContent_topreview6, _reviewContent_topreview7, _reviewContent_topreview8;
    const [openModalReply, setOpenModalReply] = (0,react.useState)(false);
    const urlUserAvatar = (0,react.useMemo)(()=>{
        var _reviewContent_topreview, _reviewContent_topreview_createdBy, _reviewContent_topreview1;
        if (reviewContent === null || reviewContent === void 0 ? void 0 : (_reviewContent_topreview = reviewContent.topreview) === null || _reviewContent_topreview === void 0 ? void 0 : (_reviewContent_topreview_createdBy = _reviewContent_topreview.createdBy) === null || _reviewContent_topreview_createdBy === void 0 ? void 0 : _reviewContent_topreview_createdBy.avatar) {
            var _reviewContent_topreview2, _reviewContent_topreview_createdBy1;
            return reviewContent === null || reviewContent === void 0 ? void 0 : (_reviewContent_topreview2 = reviewContent.topreview) === null || _reviewContent_topreview2 === void 0 ? void 0 : (_reviewContent_topreview_createdBy1 = _reviewContent_topreview2.createdBy) === null || _reviewContent_topreview_createdBy1 === void 0 ? void 0 : _reviewContent_topreview_createdBy1.avatar;
        } else if (reviewContent === null || reviewContent === void 0 ? void 0 : (_reviewContent_topreview1 = reviewContent.topreview) === null || _reviewContent_topreview1 === void 0 ? void 0 : _reviewContent_topreview1.nickName) {
            return null;
        } else return "".concat(environment/* STATIC_DOMAIN */.xm, "/").concat(constants_image/* DEFAULT_USER_AVATAR */._D);
    }, [
        reviewContent
    ]);
    const userAction = (0,react.useMemo)(()=>{
        var _reviewContent_topreview;
        switch(reviewContent === null || reviewContent === void 0 ? void 0 : (_reviewContent_topreview = reviewContent.topreview) === null || _reviewContent_topreview === void 0 ? void 0 : _reviewContent_topreview.type){
            case comment/* CommentTypeEnum.QUESTION */.I.QUESTION:
                return {
                    title: "đ\xe3 hỏi",
                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                        className: "mrv mrv-contact_support text-fs-20 leading-5 text-grey-400"
                    }),
                    buttonTitle: "Trả lời ngay"
                };
            case comment/* CommentTypeEnum.REVIEW */.I.REVIEW:
                return {
                    title: "đ\xe3 viết review",
                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                        className: "mrv mrv-review text-fs-20 leading-5 text-grey-400"
                    }),
                    buttonTitle: "Phản hồi"
                };
            default:
                return {
                    title: "đ\xe3 phản hồi",
                    icon: null,
                    buttonTitle: null
                };
        }
    }, [
        reviewContent
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: " gap-4 p-3 w-full bg-white rounded-lg shadow hover:shadow-xl duration-300",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "pb-2 border-b border-b-grey-200",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex gap-2 mb-2",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "w-9 h-9 relative flex-0 rounded-xl",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MeeyImage/* default */.Z, {
                                    src: reviewContent.logo ? reviewContent.logo.uri : "".concat(environment/* STATIC_DOMAIN */.xm, "/").concat(project_constant/* DEFAULT_LOGO_PROJECT */.J3),
                                    alt: reviewContent.title,
                                    resizeOnFly: reviewContent.logo ? true : false,
                                    resizeOptions: {
                                        width: 0,
                                        height: 108
                                    },
                                    className: "w-full h-full absolute object-contain rounded-md"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex-1 justify-between items-center w-full ",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: "/project/".concat(reviewContent === null || reviewContent === void 0 ? void 0 : reviewContent.slug, "-").concat((reviewContent === null || reviewContent === void 0 ? void 0 : reviewContent.shortId) ? reviewContent === null || reviewContent === void 0 ? void 0 : reviewContent.shortId : reviewContent === null || reviewContent === void 0 ? void 0 : reviewContent._id),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "text-fs-14 text-grey-700 font-semibold line-clamp-1 w-full break-all",
                                            children: [
                                                reviewContent === null || reviewContent === void 0 ? void 0 : reviewContent.title,
                                                " "
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "text-[11px] text-grey-500 mt-0.5",
                                        children: (0,utils/* convertAddressNoStreet */.NL)(reviewContent)
                                    })
                                ]
                            })
                        ]
                    }),
                    (reviewContent === null || reviewContent === void 0 ? void 0 : reviewContent.voteScore) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex items-center gap-1 h-4",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "text-fs-14 text-grey-700 font-semibold ",
                                children: (reviewContent === null || reviewContent === void 0 ? void 0 : reviewContent.voteScore) ? reviewContent === null || reviewContent === void 0 ? void 0 : (_reviewContent_voteScore = reviewContent.voteScore) === null || _reviewContent_voteScore === void 0 ? void 0 : _reviewContent_voteScore.toFixed(1) : 0
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(MeeyRate/* default */.Z, {
                                disable: true,
                                value: reviewContent === null || reviewContent === void 0 ? void 0 : reviewContent.voteScore,
                                itemClassName: "!text-fs-20"
                            })
                        ]
                    }) : null
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex-1",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: " mt-2.5 items-center gap-4",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(UserTime/* default */.Z, {
                            src: urlUserAvatar,
                            name: (reviewContent === null || reviewContent === void 0 ? void 0 : (_reviewContent_topreview = reviewContent.topreview) === null || _reviewContent_topreview === void 0 ? void 0 : _reviewContent_topreview.nickName) || "Ẩn danh",
                            className: "w-fit",
                            textClass: "text-fs-14 text-grey-600 line-clamp-1",
                            size: 32,
                            time: reviewContent === null || reviewContent === void 0 ? void 0 : (_reviewContent_topreview1 = reviewContent.topreview) === null || _reviewContent_topreview1 === void 0 ? void 0 : _reviewContent_topreview1.publishedAt,
                            haveAction: true,
                            actionTitle: userAction.title,
                            actionIcon: userAction.icon,
                            maxLengthName: 15
                        })
                    }),
                    (reviewContent === null || reviewContent === void 0 ? void 0 : (_reviewContent_topreview2 = reviewContent.topreview) === null || _reviewContent_topreview2 === void 0 ? void 0 : _reviewContent_topreview2.comment) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "mt-2 text-fs-14 text-grey-700 break-word",
                        children: [
                            "“",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ReviewShowTextContent/* default */.Z, {
                                content: reviewContent === null || reviewContent === void 0 ? void 0 : (_reviewContent_topreview3 = reviewContent.topreview) === null || _reviewContent_topreview3 === void 0 ? void 0 : _reviewContent_topreview3.comment,
                                limit: 200
                            }),
                            (reviewContent === null || reviewContent === void 0 ? void 0 : (_reviewContent_topreview4 = reviewContent.topreview) === null || _reviewContent_topreview4 === void 0 ? void 0 : (_reviewContent_topreview_comment = _reviewContent_topreview4.comment) === null || _reviewContent_topreview_comment === void 0 ? void 0 : _reviewContent_topreview_comment.length) > 200 ? " ..." : null,
                            "”"
                        ]
                    }) : null,
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        onClick: ()=>{
                            var _reviewContent_topreview;
                            if (!(reviewContent === null || reviewContent === void 0 ? void 0 : (_reviewContent_topreview = reviewContent.topreview) === null || _reviewContent_topreview === void 0 ? void 0 : _reviewContent_topreview.isReply)) {
                                setOpenModalReply(true);
                            }
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(common_ListFileReview["default"], {
                            data: reviewContent === null || reviewContent === void 0 ? void 0 : reviewContent.topreview,
                            maxFileShow: 4
                        })
                    }),
                    (reviewContent === null || reviewContent === void 0 ? void 0 : (_reviewContent_topreview5 = reviewContent.topreview) === null || _reviewContent_topreview5 === void 0 ? void 0 : _reviewContent_topreview5.isReply) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "h-9 w-full flex justify-end",
                        children: (reviewContent === null || reviewContent === void 0 ? void 0 : (_reviewContent_topreview6 = reviewContent.topreview) === null || _reviewContent_topreview6 === void 0 ? void 0 : _reviewContent_topreview6.type) == comment/* CommentTypeEnum.REVIEW */.I.REVIEW ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex items-center gap-1",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "text-fs-14 text-grey-600 font-medium",
                                    children: "Đ\xe3 phản hồi"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                    className: "mrv mrv-check_circle text-fs-18 text-green-500"
                                })
                            ]
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex items-center gap-1",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "text-fs-14 text-grey-600 font-medium",
                                    children: "Đ\xe3 trả lời"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                    className: "mrv mrv-check_circle text-fs-18 text-green-500"
                                })
                            ]
                        })
                    }) : (reviewContent === null || reviewContent === void 0 ? void 0 : (_reviewContent_topreview7 = reviewContent.topreview) === null || _reviewContent_topreview7 === void 0 ? void 0 : _reviewContent_topreview7.type) != comment/* CommentTypeEnum.REPLY */.I.REPLY ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "w-full flex justify-end mt-2 h-9",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                            btnType: "filled",
                            onClick: ()=>setOpenModalReply(true),
                            className: (0,clsx_m/* default */.Z)("w-[106px] !border-none p-0 text-fs-14 font-medium flex justify-center", (reviewContent === null || reviewContent === void 0 ? void 0 : (_reviewContent_topreview8 = reviewContent.topreview) === null || _reviewContent_topreview8 === void 0 ? void 0 : _reviewContent_topreview8.type) == comment/* CommentTypeEnum.REVIEW */.I.REVIEW ? "!bg-blue-500" : "!bg-purple-500"),
                            children: userAction.buttonTitle
                        })
                    }) : null,
                    openModalReply ? /*#__PURE__*/ (0,jsx_runtime.jsx)(BoxInfo_ModalReplyFollowProject, {
                        open: openModalReply,
                        onClose: ()=>setOpenModalReply(false),
                        reviewContent: reviewContent,
                        userAction: userAction,
                        urlUserAvatar: urlUserAvatar
                    }) : null
                ]
            })
        ]
    });
};
/* harmony default export */ var BoxInfo_FollowProjectCard = (FollowProjectCard);

// EXTERNAL MODULE: ./src/components/ReviewInputComponent.tsx/DocViewerPreview.tsx
var DocViewerPreview = __webpack_require__(98907);
// EXTERNAL MODULE: ./src/components/VideoPlayer.tsx
var VideoPlayer = __webpack_require__(19534);
// EXTERNAL MODULE: ./node_modules/react-zoom-pan-pinch/dist/index.esm.js
var index_esm = __webpack_require__(26126);
;// CONCATENATED MODULE: ./src/modules/Desktop/Home/Newest/BoxInfo/ModalDetailFileFollow.tsx











const ModalViewDetailFileFollow = ()=>{
    const { selectedViewFiles , setSelectedViewFiles  } = (0,react.useContext)(home_context/* HomeContext */.Q);
    const [mounted, setMounted] = (0,react.useState)(false);
    (0,react.useEffect)(()=>{
        setMounted(true);
    }, []);
    const currentIndexFile = (0,react.useMemo)(()=>{
        return selectedViewFiles === null || selectedViewFiles === void 0 ? void 0 : selectedViewFiles.files.findIndex((item)=>{
            var _selectedViewFiles_currentFile;
            return item._id == (selectedViewFiles === null || selectedViewFiles === void 0 ? void 0 : (_selectedViewFiles_currentFile = selectedViewFiles.currentFile) === null || _selectedViewFiles_currentFile === void 0 ? void 0 : _selectedViewFiles_currentFile._id);
        });
    }, [
        selectedViewFiles
    ]);
    return mounted ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: (selectedViewFiles === null || selectedViewFiles === void 0 ? void 0 : selectedViewFiles.currentFile) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "fixed top-0 z-40 left-0 w-screen h-screen bg-black-1000 overflow-hidden custom-modal-preview-file flex flex-col flex-[1_auto_1] gap-2 p-4",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* TransformWrapper */.d$, {
                initialScale: 1,
                disabled: !(selectedViewFiles === null || selectedViewFiles === void 0 ? void 0 : selectedViewFiles.currentFile.name.match(constants_file/* fileType.image */.r.image)),
                children: (param)=>{
                    let { zoomIn , zoomOut , resetTransform , ...rest } = param;
                    var _selectedViewFiles_currentFile, _selectedViewFiles_currentFile1, _selectedViewFiles_files, _selectedViewFiles_files1;
                    /*#__PURE__*/ return (0,jsx_runtime.jsxs)(react.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "flex items-center justify-between",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                    className: "mrv mrv-close text-white text-fs-32 leading-[2rem] cursor-pointer",
                                    onClick: ()=>{
                                        setSelectedViewFiles(null);
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "h-[80vh] w-full flex justify-between items-center gap-6",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                        onClick: ()=>{
                                            if (currentIndexFile != 0) {
                                                resetTransform();
                                                setSelectedViewFiles({
                                                    ...selectedViewFiles,
                                                    currentFile: selectedViewFiles === null || selectedViewFiles === void 0 ? void 0 : selectedViewFiles.files[currentIndexFile - 1]
                                                });
                                            }
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                            className: (0,clsx_m/* default */.Z)("mrv mrv-chevron_left  text-fs-32 leading-[32px]", currentIndexFile == 0 ? "cursor-not-allowed text-grey-100" : "text-white")
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "w-full h-full",
                                        children: (selectedViewFiles === null || selectedViewFiles === void 0 ? void 0 : selectedViewFiles.currentFile.name.match(constants_file/* fileType.image */.r.image)) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* TransformComponent */.Uv, {
                                            contentClass: "!h-full !w-full flex justify-between items-center",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "w-full h-full flex justify-center",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    src: selectedViewFiles.currentFile.uri.match(constants_file/* fileType.resizeImageSupport */.r.resizeImageSupport) ? (0,utils/* resizeOnFlyUrl */.Li)({
                                                        uri: selectedViewFiles.currentFile.uri,
                                                        width: 0,
                                                        height: 0,
                                                        gravity: "ce",
                                                        resizingType: "auto"
                                                    }) : selectedViewFiles.currentFile.url,
                                                    alt: "test",
                                                    className: "w-[inherit] h-full absolute object-contain"
                                                })
                                            })
                                        }) : (selectedViewFiles === null || selectedViewFiles === void 0 ? void 0 : selectedViewFiles.currentFile.name.match(constants_file/* fileType.video */.r.video)) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* TransformComponent */.Uv, {
                                            contentClass: "!h-full !w-full flex justify-between items-center",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(VideoPlayer/* default */.Z, {
                                                options: {
                                                    autoplay: true,
                                                    muted: true,
                                                    controls: true,
                                                    responsive: true,
                                                    fluid: true,
                                                    sources: [
                                                        {
                                                            src: selectedViewFiles === null || selectedViewFiles === void 0 ? void 0 : selectedViewFiles.currentFile.urlVod
                                                        }
                                                    ]
                                                }
                                            }, selectedViewFiles === null || selectedViewFiles === void 0 ? void 0 : (_selectedViewFiles_currentFile = selectedViewFiles.currentFile) === null || _selectedViewFiles_currentFile === void 0 ? void 0 : _selectedViewFiles_currentFile.urlVod)
                                        }) : (selectedViewFiles === null || selectedViewFiles === void 0 ? void 0 : selectedViewFiles.currentFile.name.match(constants_file/* fileType.viewFileSupport */.r.viewFileSupport)) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* TransformComponent */.Uv, {
                                            contentClass: "!h-full !w-full flex justify-between items-center",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DocViewerPreview["default"], {
                                                url: selectedViewFiles === null || selectedViewFiles === void 0 ? void 0 : selectedViewFiles.currentFile.url
                                            })
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* TransformComponent */.Uv, {
                                            contentClass: "!h-full !w-full flex justify-center items-center",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "w-[685px] h-[196px] rounded-xl p-6 flex flex-col justify-center gap-4 bg-grey-100",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "flex items-center gap-1",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                                className: "mrv mrv-docs text-fs-36 text-grey-700"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: "flex flex-col text-grey-700",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                        className: "text-base font-medium text-grey-800 line-clamp-1 break-words w-full",
                                                                        title: selectedViewFiles === null || selectedViewFiles === void 0 ? void 0 : selectedViewFiles.currentFile.name,
                                                                        children: selectedViewFiles === null || selectedViewFiles === void 0 ? void 0 : selectedViewFiles.currentFile.name
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                        className: "text-fs-12",
                                                                        children: [
                                                                            (selectedViewFiles === null || selectedViewFiles === void 0 ? void 0 : selectedViewFiles.currentFile.size) / 1000,
                                                                            " MB"
                                                                        ]
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "text-fs-20 text-grey-800 font-semibold",
                                                        children: "Kh\xf4ng thể xem trước tệp n\xe0y. Vui l\xf2ng tải xuống để xem nội dung"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        href: selectedViewFiles === null || selectedViewFiles === void 0 ? void 0 : (_selectedViewFiles_currentFile1 = selectedViewFiles.currentFile) === null || _selectedViewFiles_currentFile1 === void 0 ? void 0 : _selectedViewFiles_currentFile1.url,
                                                        download: true,
                                                        target: "_blank",
                                                        className: "flex justify-center w-full",
                                                        rel: "noreferrer",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button/* default */.Z, {
                                                            className: "meey-button meey-button-primary meey-button-filled py-2.5 px-4 h-11 flex items-center gap-1 w-fit ",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                                    className: "mrv mrv-download text-fs-20"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                    className: "text-fs-16 font-semibold",
                                                                    children: "Tải xuống"
                                                                })
                                                            ]
                                                        })
                                                    })
                                                ]
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                        onClick: ()=>{
                                            var _selectedViewFiles_files;
                                            if (currentIndexFile < (selectedViewFiles === null || selectedViewFiles === void 0 ? void 0 : (_selectedViewFiles_files = selectedViewFiles.files) === null || _selectedViewFiles_files === void 0 ? void 0 : _selectedViewFiles_files.length) - 1) {
                                                resetTransform();
                                                setSelectedViewFiles({
                                                    ...selectedViewFiles,
                                                    currentFile: selectedViewFiles === null || selectedViewFiles === void 0 ? void 0 : selectedViewFiles.files[currentIndexFile + 1]
                                                });
                                            }
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                            className: (0,clsx_m/* default */.Z)("mrv mrv-chevron_right  text-fs-32 leading-[32px]", currentIndexFile == (selectedViewFiles === null || selectedViewFiles === void 0 ? void 0 : (_selectedViewFiles_files = selectedViewFiles.files) === null || _selectedViewFiles_files === void 0 ? void 0 : _selectedViewFiles_files.length) - 1 ? "cursor-not-allowed text-grey-100" : "text-white")
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "w-full flex justify-center",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: " p-2 rounded-lg text-fs-12 text-grey-600 flex gap-2 flex-[0_0_auto] max-w-[792px] overflow-x-auto",
                                    children: (selectedViewFiles.maxFileShow ? selectedViewFiles === null || selectedViewFiles === void 0 ? void 0 : (_selectedViewFiles_files1 = selectedViewFiles.files) === null || _selectedViewFiles_files1 === void 0 ? void 0 : _selectedViewFiles_files1.slice(currentIndexFile, currentIndexFile + selectedViewFiles.maxFileShow) : selectedViewFiles.files).map((file)=>{
                                        var _selectedViewFiles_currentFile, _file_name_split;
                                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (0,clsx_m/* default */.Z)("relative group cursor-pointer h-fit flex-0 rounded-lg duration-300 border-2", file.name.match(constants_file/* fileType.image */.r.image) || file.name.match(constants_file/* fileType.video */.r.video) ? "can-preview-upload" : "default-file", file.s3Key === ((_selectedViewFiles_currentFile = selectedViewFiles.currentFile) === null || _selectedViewFiles_currentFile === void 0 ? void 0 : _selectedViewFiles_currentFile.s3Key) ? " !border-blue-500" : ""),
                                            children: [
                                                file.name.match(constants_file/* fileType.image */.r.image) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "w-[4.5rem] h-[4.5rem] bg-grey-200 rounded-md flex flex-col relative cursor-pointer",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: " text-fs-12 w-full h-full overflow-hidden rounded-md",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MeeyImage/* default */.Z, {
                                                            className: "object-cover w-full h-full",
                                                            src: file.uri,
                                                            alt: file.name,
                                                            resizeOptions: {
                                                                width: 0,
                                                                height: 0
                                                            }
                                                        })
                                                    })
                                                }) : file.name.match(constants_file/* fileType.video */.r.video) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "w-[4.5rem] h-[4.5rem] bg-grey-200 rounded-md flex flex-col relative cursor-pointer",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: " text-fs-12 w-full h-full overflow-hidden rounded-b-md",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("video", {
                                                                src: file.url
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "absolute top-1/2 left-1/2 -translate-y-1/2 -translate-x-1/2",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                                    className: "mrv mrv-play_arrow text-white text-fs-24 font-bold"
                                                                })
                                                            })
                                                        ]
                                                    })
                                                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "w-[4.5rem] h-[4.5rem] bg-grey-200 rounded-md flex flex-col relative cursor-pointer border border-transparent border-dashed",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "flex-[0_0_36px] w-full flex items-center",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: "-rotate-90 w-fit mr-2",
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                                        className: "mrv mrv-attachment text-fs-20 "
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                    children: [
                                                                        ".",
                                                                        (_file_name_split = file.name.split(".")) === null || _file_name_split === void 0 ? void 0 : _file_name_split.pop()
                                                                    ]
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "bg-grey-300 flex-[1_1_auto] text-fs-12 py-1 px-2 overflow-hidden rounded-b-md",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                className: "line-clamp-2",
                                                                children: file.name
                                                            })
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    onClick: ()=>{
                                                        resetTransform();
                                                        setSelectedViewFiles({
                                                            ...selectedViewFiles,
                                                            currentFile: file
                                                        });
                                                    },
                                                    className: "cursor-pointer absolute w-full h-full top-0 z-30 bg-[rgba(0,0,0,0.4)] flex items-center justify-center opacity-0 group-hover:opacity-100 rounded-md duration-300",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                        className: "mrv mrv-preview text-white text-fs-20"
                                                    })
                                                })
                                            ]
                                        }, file.s3Key);
                                    })
                                })
                            })
                        ]
                    });
                }
            })
        }) : null
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
};
/* harmony default export */ var ModalDetailFileFollow = (ModalViewDetailFileFollow);

;// CONCATENATED MODULE: ./src/modules/Desktop/Home/Newest/BoxInfo/ListFollowProject.tsx





const ListFollowProject = ()=>{
    var _listFollowProject_results;
    const { listFollowProject  } = (0,react.useContext)(home_context/* HomeContext */.Q);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: (listFollowProject === null || listFollowProject === void 0 ? void 0 : listFollowProject.results) && (listFollowProject === null || listFollowProject === void 0 ? void 0 : (_listFollowProject_results = listFollowProject.results) === null || _listFollowProject_results === void 0 ? void 0 : _listFollowProject_results.length) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "uppercase text-grey-700 text-fs-14 font-semibold mb-1 py-2",
                    children: "\uD83D\uDC42 dự \xe1n đang h\xf3ng"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "flex flex-col gap-3",
                    children: listFollowProject === null || listFollowProject === void 0 ? void 0 : listFollowProject.results.map((item, index)=>{
                        /*#__PURE__*/ return (0,jsx_runtime.jsx)(BoxInfo_FollowProjectCard, {
                            reviewContent: item
                        }, item === null || item === void 0 ? void 0 : item._id);
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalDetailFileFollow, {})
            ]
        }) : null
    });
};
/* harmony default export */ var BoxInfo_ListFollowProject = (ListFollowProject);

// EXTERNAL MODULE: ./src/components/AvatarWithName.tsx
var AvatarWithName = __webpack_require__(7869);
;// CONCATENATED MODULE: ./src/modules/Desktop/Home/Newest/BoxInfo/TopMembers.tsx






const TopMembers = ()=>{
    const { listTopMember  } = (0,react.useContext)(home_context/* HomeContext */.Q);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: listTopMember && (listTopMember === null || listTopMember === void 0 ? void 0 : listTopMember.length) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "uppercase text-grey-700 text-fs-14 font-semibold mb-1 py-2",
                    children: "Th\xe0nh vi\xean t\xedch cực nhất ⭐⭐️⭐️️"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "py-4 px-3 w-full bg-white rounded-lg shadow hover:shadow-xl duration-300 flex flex-col gap-4",
                    children: listTopMember.map((item, index)=>{
                        var _item_name, _item_name1;
                        /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
                            className: "flex items-center gap-2",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "relative",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(AvatarWithName/* default */.Z, {
                                            imageClass: "!w-10 !h-10",
                                            imageProps: {
                                                resizeOnFly: false
                                            },
                                            className: "flex-0 border border-solid border-black-50 rounded-full",
                                            avatarOnly: true,
                                            name: item === null || item === void 0 ? void 0 : item.name,
                                            src: (item === null || item === void 0 ? void 0 : item.avatar) ? item.avatar : null
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            src: environment/* STATIC_DOMAIN */.xm + "/images/top".concat(index + 1, ".svg"),
                                            alt: "top-icon",
                                            className: "absolute top-6 right-0"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex flex-col",
                                    children: [
                                        (item === null || item === void 0 ? void 0 : (_item_name = item.name) === null || _item_name === void 0 ? void 0 : _item_name.length) > 25 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(PopOver/* default */.Z, {
                                            trigger: "hover",
                                            dropdownClassName: "mt-2 !p-0 rounded !bg-transparent",
                                            content: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "py-1 px-2 bg-black-800 text-fs-14 text-white max-w-[30rem] break-word",
                                                children: item === null || item === void 0 ? void 0 : item.name
                                            }),
                                            position: "top-left",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "text-grey-800 text-fs-16 font-medium line-clamp-1 break-all w-full",
                                                children: (item === null || item === void 0 ? void 0 : (_item_name1 = item.name) === null || _item_name1 === void 0 ? void 0 : _item_name1.substring(0, 25)) + "..."
                                            })
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "text-grey-800 text-fs-16 font-medium line-clamp-1 break-all w-full",
                                            children: item === null || item === void 0 ? void 0 : item.name
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "text-grey-600 text-fs-14",
                                            children: [
                                                item === null || item === void 0 ? void 0 : item.total,
                                                " b\xecnh luận"
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }, item === null || item === void 0 ? void 0 : item._id);
                    })
                })
            ]
        }) : null
    });
};
/* harmony default export */ var BoxInfo_TopMembers = (TopMembers);

;// CONCATENATED MODULE: ./src/modules/Desktop/Home/Newest/BoxInfo/index.tsx






const BoxInfo = ()=>{
    const { token  } = (0,useAuth/* useAuth */.a)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex-[0_0_19.5rem] overflow-auto flex flex-col gap-6",
        children: [
            token ? /*#__PURE__*/ (0,jsx_runtime.jsx)(BoxInfo_ListFollowProject, {}) : null,
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Home_SeenProjects, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BoxInfo_TopMembers, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BoxInfo_CommentStorm, {})
        ]
    });
};
/* harmony default export */ var Newest_BoxInfo = (BoxInfo);

;// CONCATENATED MODULE: ./src/modules/Desktop/Home/Newest/index.tsx








const Newest = ()=>{
    const { listReviews , activeTab , currentPage , setCurrentPage  } = (0,react.useContext)(home_context/* HomeContext */.Q);
    var _listReviews_results;
    const [projectReviews, setProjectReviews] = (0,react.useState)((_listReviews_results = listReviews === null || listReviews === void 0 ? void 0 : listReviews.results) !== null && _listReviews_results !== void 0 ? _listReviews_results : []);
    (0,react.useEffect)(()=>{
        setProjectReviews([]);
        setCurrentPage(1);
    }, [
        activeTab
    ]);
    (0,react.useEffect)(()=>{
        var _listReviews_results;
        if ((listReviews === null || listReviews === void 0 ? void 0 : listReviews.results) && (listReviews === null || listReviews === void 0 ? void 0 : (_listReviews_results = listReviews.results) === null || _listReviews_results === void 0 ? void 0 : _listReviews_results.length)) {
            if ((listReviews === null || listReviews === void 0 ? void 0 : listReviews.page) == 1) {
                setProjectReviews([
                    ...listReviews === null || listReviews === void 0 ? void 0 : listReviews.results
                ]);
            } else {
                setProjectReviews([
                    ...projectReviews,
                    ...listReviews === null || listReviews === void 0 ? void 0 : listReviews.results
                ]);
            }
        }
    }, [
        listReviews === null || listReviews === void 0 ? void 0 : listReviews.results
    ]);
    const getListProjectReview = async ()=>{
        const res = await (0,get_list/* getListReviews */.V)(activeTab, {
            page: currentPage + 1,
            limit: number/* PAGE_SIZE_REVIEWS */.CC
        });
        setCurrentPage(currentPage + 1);
        if (res) {
            setProjectReviews([
                ...projectReviews,
                ...res === null || res === void 0 ? void 0 : res.results
            ]);
        }
    };
    const onLoadMore = ()=>{
        getListProjectReview();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: " mt-5 flex gap-6",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "pb-4 overflow-x-hidden overflow-y-auto w-full",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* default */.Z, {
                    dataLength: (projectReviews === null || projectReviews === void 0 ? void 0 : projectReviews.length) || 0,
                    next: onLoadMore,
                    hasMore: (projectReviews === null || projectReviews === void 0 ? void 0 : projectReviews.length) < (listReviews === null || listReviews === void 0 ? void 0 : listReviews.totalResults),
                    loader: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "px-4 flex items-center justify-center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "dot-flashing"
                        })
                    }),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex-1 gap-y-3 flex flex-col",
                        children: projectReviews && projectReviews.map((item)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(Home_HomeProjectCard, {
                                data: item
                            }, item._id))
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Newest_BoxInfo, {})
        ]
    });
};
/* harmony default export */ var Home_Newest = (Newest);

// EXTERNAL MODULE: ./src/modules/Desktop/ListSearchProject/HeaderListSearch.tsx
var HeaderListSearch = __webpack_require__(51329);
;// CONCATENATED MODULE: ./src/modules/Desktop/Home/index.tsx









const HOME_TABS = [
    {
        label: "Mới nhất",
        key: "lastest",
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
            className: "mrv mrv-timelapse text-fs-20"
        }),
        component: /*#__PURE__*/ (0,jsx_runtime.jsx)(Home_Newest, {})
    },
    {
        label: "Top review",
        key: "topreview",
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
            className: "mrv mrv-trending_up text-fs-20"
        }),
        component: /*#__PURE__*/ (0,jsx_runtime.jsx)(Home_Newest, {})
    },
    {
        label: "Hot",
        key: "hot",
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
            className: "mrv mrv-local_fire_department text-fs-20"
        }),
        component: /*#__PURE__*/ (0,jsx_runtime.jsx)(Home_Newest, {})
    }
];
const HomeComponent = ()=>{
    var _HOME_TABS_find;
    const { activeTab , setActiveTab , setListFollowProject , handleFetchData  } = (0,react.useContext)(home_context/* HomeContext */.Q);
    const { token  } = (0,useAuth/* useAuth */.a)();
    const handleSelectTab = (tab)=>{
        handleFetchData(tab);
        setActiveTab(tab);
    };
    const [isShowScrolHeader, setIsShowScrollHeader] = (0,react.useState)(false);
    const handleGetListFollowProject = async ()=>{
        const res = await (0,get_list_follow_project/* getListFollowProject */.q)(token);
        if (res) {
            setListFollowProject(res);
        }
    };
    (0,react.useEffect)(()=>{
        if (token) {
            handleGetListFollowProject();
        }
    }, [
        token
    ]);
    const handleScroll = ()=>{
        const position = window.scrollY;
        setIsShowScrollHeader(position > 276);
    };
    (0,react.useEffect)(()=>{
        window.addEventListener("scroll", handleScroll, {
            passive: true
        });
        return ()=>{
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "wrap-home bg-grey-100 min-h-[calc(100vh-77px)]",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderListSearch/* default */.Z, {
                showSearch: true,
                isShowScrolHeader: isShowScrolHeader
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Home_HeaderHome, {
                isShowScrolHeader: isShowScrolHeader
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "layout pb-6 pt-[3.5rem]",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "home-tabs",
                        children: HOME_TABS.map((tab)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (0,clsx_m/* default */.Z)("home-tab", activeTab === tab.key ? "home-tab-active" : ""),
                                onClick: ()=>handleSelectTab(tab.key),
                                children: [
                                    tab.icon,
                                    " ",
                                    tab.label
                                ]
                            }, tab.key))
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "home-tab-content ",
                        children: (_HOME_TABS_find = HOME_TABS.find((tab)=>tab.key === activeTab)) === null || _HOME_TABS_find === void 0 ? void 0 : _HOME_TABS_find.component
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var Home = (HomeComponent);


/***/ })

}]);